import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ellipsis',
    standalone: false
})
export class EllipsisPipe implements PipeTransform {
  transform(value: string, length: number = 20): string {
    if (value.length > length) {
      return value.slice(0, length) + '...';
    }
    return value;
  }
}